import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaStar, FaUserMd, FaShareAlt, FaRegHeart, FaArrowRight } from 'react-icons/fa';
import Base from './Base';

function Hospitals() {
  const hospitals = [
    {
      name: "Genome Wise Medical Center",
      address: "123 St Maris Street, Kentacy, USA",
      rating: "2k+ Rating",
      doctors: "40 Doctors",
      img: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=600"
    },
    {
      name: "Nanotexh Health Care Solutions",
      address: "234 St Street, Carolina, UK",
      rating: "4k+ Rating",
      doctors: "35 Doctors",
      img: "https://images.unsplash.com/photo-1586773860418-d3b9797d16d0?auto=format&fit=crop&q=80&w=600"
    },
    {
      name: "Premier Health Center",
      address: "120 Lake Kenn, North Dakota, UK",
      rating: "5k+ Rating",
      doctors: "60 Doctors",
      img: "https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&q=80&w=600"
    },
    {
      name: "City General Hospital",
      address: "456 Main Ave, New York, USA",
      rating: "3k+ Rating",
      doctors: "50 Doctors",
      img: "https://images.unsplash.com/photo-1538108149393-fdfd8169367d?auto=format&fit=crop&q=80&w=600"
    },
    {
      name: "St. Mary's Children's Clinic",
      address: "789 Pine Road, London, UK",
      rating: "1.5k+ Rating",
      doctors: "25 Doctors",
      img: "https://images.unsplash.com/photo-1502740479796-61c9fe175391?auto=format&fit=crop&q=80&w=600"
    },
    {
      name: "Hope Medical Institute",
      address: "101 Hope Blvd, Sydney, AU",
      rating: "6k+ Rating",
      doctors: "80 Doctors",
      img: "https://images.unsplash.com/photo-1512678080530-7760d81faba6?auto=format&fit=crop&q=80&w=600"
    }
  ];

  return (
    <Base>
      <div className="dark:bg-dark min-h-screen transition-colors duration-200">
        <Helmet><title>Hospitals | Aman Medical Complex Gilgit</title></Helmet>

        <section className="relative py-32 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://images.unsplash.com/photo-1512678080530-7760d81faba6?auto=format&fit=crop&q=80&w=1600"
              alt="Medical Header Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#002147]/80 dark:bg-gray-900/90"></div>
          </div>
          <div className="container mx-auto px-4 text-center relative z-10">
            <h1 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">Our Hospitals</h1>
            <div className="flex items-center justify-center gap-2 text-[#007bff] font-bold uppercase tracking-[0.2em] text-sm">
              <Link to="/" className="hover:text-white transition-colors">Home</Link>
              <span>/</span>
              <span className="text-white/60">Hospitals</span>
            </div>
          </div>
        </section>

        <section className="py-24 container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {hospitals.map((hosp, i) => (
              <div key={i} className="bg-white dark:bg-gray-700 rounded-[40px] overflow-hidden shadow-xl border border-gray-100 dark:border-gray-600 group hover:-translate-y-2 transition-all duration-300">
                <div className="relative h-72 overflow-hidden bg-gray-100">
                  <img src={hosp.img} alt={hosp.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute top-5 left-5 right-5 flex justify-between items-start opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <button className="w-11 h-11 bg-white rounded-xl flex items-center justify-center text-primary shadow-xl hover:bg-primary hover:text-white transition-all transform hover:scale-110 active:scale-95">
                      <FaShareAlt size={18} />
                    </button>
                    <button className="w-11 h-11 bg-white rounded-xl flex items-center justify-center text-primary shadow-xl hover:bg-primary hover:text-white transition-all transform hover:scale-110 active:scale-95">
                      <FaRegHeart size={18} />
                    </button>
                  </div>
                </div>
                <div className="p-8">
                  <div className="flex justify-between items-center mb-6">
                    <span className="bg-[#f0f7ff] text-[#007bff] px-5 py-2 rounded-xl font-bold text-[10px] uppercase tracking-wider">Hospital</span>
                    <div className="flex items-center gap-1.5 font-bold">
                      <div className="flex text-orange-400 text-xs">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </div>
                      <span className="text-xs text-gray-500 dark:text-gray-400">{hosp.rating}</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-black text-[#002147] dark:text-white mb-2 group-hover:text-primary transition-colors leading-tight">
                    {hosp.name}
                  </h3>
                  <div className="flex items-center gap-3 text-gray-500 dark:text-gray-400 text-xs font-bold mb-8">
                    <FaMapMarkerAlt className="text-primary text-sm" />
                    {hosp.address}
                  </div>

                  <div className="flex items-center justify-between gap-3 border-t border-gray-50 dark:border-gray-600 pt-7">
                    <Link to="/appointment" className="group/btn h-12 flex-1 bg-[#f0f6ff] text-primary rounded-2xl font-black text-xs flex items-center justify-center gap-2 hover:bg-primary hover:text-white transition-all duration-300">
                      Book Today <FaArrowRight size={12} className="group-hover/btn:translate-x-1 transition-transform" />
                    </Link>
                    <div className="flex items-center justify-end gap-2 text-gray-700 dark:text-gray-300 font-extrabold text-xs flex-1">
                      <FaUserMd className="text-primary text-base" />
                      {hosp.doctors}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </Base>
  );
}

export default Hospitals;

